// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3grnM","placeholdersHeader":"styles_placeholdersHeader__1iAJr","editorStyle":"styles_editorStyle__1lsvk","placeholdersBox":"styles_placeholdersBox__3thjm"};